import * as React from 'react';
import { isRequestCreateSkipDropdownInitialOptionsCallEnabled } from '@helpcenter/feature-flags';
import { debounce } from 'lodash';
import { searchUser } from 'rest/user';
import type { UserPickerDumbProps, UserPickerOption, User } from './user-picker-dumb';
import { UserPickerDumb } from './user-picker-dumb';

interface Props extends UserPickerDumbProps {
    portalId: number;
    fieldConfigId: string;
}

export type UserPickerProps = Omit<Props, 'loadOptions' | 'doInitialSearch'>;

export default class UserPicker extends React.PureComponent<UserPickerProps> {
    isRequestCreateSkipDropdownInitialOptionsCallEnabled = isRequestCreateSkipDropdownInitialOptionsCallEnabled();
    state = {
        initialOptions: [],
        isLoadingInitialOptions: false,
        hasFetchedInitialOptions: false,
    };

    loadOptions = (inputValue: string, callback: (options: UserPickerOption[]) => void) => {
        // Disabling existing violations, should be fixed when revisited.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.fetchUserDebounced(inputValue, callback);
    };

    fetchUsers = (inputValue: string, callback: (options: UserPickerOption[]) => void) => {
        return searchUser({
            fieldName: this.props.id,
            query: inputValue,
            portalId: this.props.portalId,
            fieldConfigId: this.props.fieldConfigId,
        })
            .map((response) =>
                response.map(
                    (user) =>
                        ({
                            value: user.id,
                            label: user.displayName,
                            iconUrl: user.avatar,
                            email: user.emailAddress,
                            accountId: user.accountId,
                        }) as User
                )
            )
            .toPromise()
            .then(callback);
    };

    fetchUserDebounced = debounce(this.fetchUsers, 400);

    handleMenuOpen = () => {
        if (!this.state.hasFetchedInitialOptions) {
            this.setState({
                hasFetchedInitialOptions: true,
                isLoadingInitialOptions: true,
            });
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.fetchUsers('', (options) =>
                this.setState({
                    isLoadingInitialOptions: false,
                    initialOptions: options,
                })
            );
        }
    };

    render() {
        return (
            <UserPickerDumb
                {...this.props}
                loadOptions={this.loadOptions}
                {...(this.isRequestCreateSkipDropdownInitialOptionsCallEnabled
                    ? {
                          onMenuOpen: this.handleMenuOpen,
                          isLoading: this.state.isLoadingInitialOptions,
                          defaultOptions: this.state.initialOptions,
                      }
                    : {
                          doInitialSearch: true,
                      })}
            />
        );
    }
}
